"use client";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { images } from "@/public";
import {
  constantText,
  footerCategories,
  footerSections,
} from "@/src/utilities/constants/constants";
import {
  Linkedin,
  Mail,
  MailIcon,
  MapPin,
  Phone,
  Twitter,
  Youtube,
} from "lucide-react";
import Image from "next/image";
import { useRouter } from "next/navigation";
import Subscribe from "./Subscribe";
const aimsLogo = "/lovable-uploads/468bf57d-9dd6-4be0-9ced-07890ca017cd.png";

const Footer = () => {
  const router = useRouter();
  return (
    <footer className="bg-theme-secondary text-white" id="footer">
      {/* Newsletter Section */}
      <Subscribe />

      {/* Main Footer Content */}
      <div className="w-full max-w-7xl mx-auto py-8 md:py-12 px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-4">
              {/* <Image
                src={"/images/AIMS.png"}
                alt="AIMS"
                width={80}
                height={40}
                // className="h-10 w-auto"
              /> */}
              <Image
                src={images.logo}
                className="w-40 h-20 cursor-pointer"
                alt="Logo"
                width={100}
                height={100}
                onClick={() => {
                  router.push("/");
                  // window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              />
            </div>
            <p className="text-white/80 mb-6 max-w-sm">
              aimsintel is a leading platform for discovering top-rated
              enterprise technology solutions and industry insights. It empowers
              professionals with expert opinions, tool comparisons, and the
              latest tech trends to make informed decisions.
            </p>
            <div className="flex items-center gap-4">
              <Button
                variant="ghost"
                size="sm"
                className="p-2 text-white hover:bg-white/10"
              >
                <Youtube className="h-4 w-4" />
              </Button>
              <Button
                variant="ghost"
                size="sm"
                className="p-2 text-white hover:bg-white/10"
              >
                <Linkedin className="h-4 w-4" />
              </Button>
            </div>
          </div>

          {/* Footer Links */}
          {footerSections.map((section) => (
            <div key={section.title}>
              <h4 className="font-semibold mb-4">{section.title}</h4>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-white/80 hover:text-white transition-colors text-sm"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Contact Info */}

        <div className="mt-8 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 md:gap-0">
          <div className="flex items-center gap-4 text-sm text-white/80">
            <div className="flex items-center gap-2">
              <MailIcon className="h-4 w-4" />
              <p>{constantText.EMAIL}</p>
            </div>
          </div>
          <div className="flex items-center gap-4 text-sm text-white/80">
            <span>© 2025 AIMS. All rights reserved.</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
